import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { MachineLearningExperiments } from './MachineLearingExperiments/MachineLearningExperiments';
import { MachineLearningExperimentResults } from './MachineLearningExperimentResults/MachineLearningExperimentResults';

export function MachineLearningRoutes(): React.ReactElement {
  return (
    <div data-testid="machine-learning-routes">
      <Switch>
        <Redirect path="/machine-learning" to="/machine-learning/experiments" exact />
        <Route path="/machine-learning/experiments" exact>
          <MachineLearningExperiments />
        </Route>
        <Route path="/machine-learning/experiments/:experimentId/results" exact>
          <MachineLearningExperimentResults />
        </Route>
      </Switch>
    </div>
  );
}
